import { Pipe, PipeTransform } from "@angular/core";
import { SurveyQuestionAnswerDTO } from "src/DTOs/PatientProcedures/Models/SurveyQuestionAnswerDTO";
import { SurveyQuestionType } from "src/core/GlobalConstants";

@Pipe({ name: 'isOptionSelected' })
export class IsOptionSelected implements PipeTransform {
  transform(question: SurveyQuestionAnswerDTO, value: string): boolean {
    if(question.QuestionType == SurveyQuestionType.MultipleChoice || question.QuestionType == SurveyQuestionType.SingleChoice)
        {
            return question.Answer.split(",").includes(value);
        }
        else if(question.QuestionType == SurveyQuestionType.Scale)
        {
            return question.Answer.split(",").includes(value);
        }     
        return false;
  }
}